var utils = require('lib/utils');
var LocaleService = require('services/locale-service');

// Application-specific Handlebars helpers
// -------------------------------------------
// TODO: revisit this helper - conflicts with resources.url property
// Get Chaplin-declared named routes. {{#url "like" "105"}}{{/url}}.
//Handlebars.registerHelper('url', function(routeName) {
//  var params = [].slice.call(arguments, 1);
//  var options = params.pop();
//  return utils.reverse(routeName, params);
//});

var HandlebarsExtensions = {
  _blocks: [],
  helpers: {
    partial: function (name, ctx, options) {
      var ps = Handlebars.partials;
      if (typeof ps[name] !== 'function')
        ps[name] = Handlebars.compile(ps[name]);
      if (options.hash) {
        ctx = $.extend({}, ctx, options.hash);
      }
      return new Handlebars.SafeString(ps[name](ctx, options));
    },
    block: function (name) {
      var blocks = HandlebarsExtensions._blocks;
      var content= blocks && blocks[name];
      if (content){
        content = new Handlebars.SafeString(content.join('\n'));
      } else {
        content = null;
      }
      return content;
    },
    content_for: function (name, options) {
      var blocks = HandlebarsExtensions._blocks;
      var block = blocks[name] || (blocks[name] = []);

      block.push(options.fn(this));
    },
    /**
     ** Warning! **
     * This exposes an XSS vulnerability that was fixed in this PR
     *   https://github.com/EverFi/ContentPartnerAPI/pull/140
     * SafeString will not HTML encode the result and as a consequence will execute script in the translation files
     *
     * Several of the views inject HTML tags to style things or add other content, so this was reverted
     *
     * To mitigate this one of two things can be done:
     *    * Don't call SafeString and just return the result of LocalService.t(key). Handlebars will HTML encode the result.
     *    * Handle the HTML encoding yourself and use SafeString since the result is already encoded
     *
    **/
    t: function(key) {
      var result = LocaleService.t(key);
      return new Handlebars.SafeString(result);
    },
    m: function(content) {
      return new Handlebars.SafeString(marked(content));
    },
    tm: function(key) {
      var result = marked(LocaleService.t(key));
      return new Handlebars.SafeString(result);
    },
    indexToCount: function(i){
      return i + 1;
    },
    assetPath: function(path){
      var fullPath = utils.coursePath(path);
      return new Handlebars.SafeString(fullPath);
    },
    times: function(n, block) {
      return [...new Array(n).keys()].reduce((result, index) => {
        var data;
        if (block.data) {
            data = Handlebars.createFrame(block.data);
        }
        if (data) {
            data.index = index;
        }
        return result += block.fn(index, {data:data});
      }, "");
    },
    style: function(value) {
      return Object.keys(value).map(e => `${e}: ${value[e]}`).join(';');
    },
    yamlize: function(value, indent) {
      let yamlized = YAML.stringify(value, Infinity);
      return indent === undefined ? yamlized : yamlized.replace(/\n/g, '\n' + ' '.repeat(indent));
    },
    jsonize: function(value) {
      return JSON.stringify(value);
    },
    equal: function(first, second) {
      return first === second;
    },
    compare: function (v1, operator, v2, options) {
      const conditions = {
        '==': (v1, v2) => v1 == v2,
        '===': (v1, v2) => v1 === v2,
        '!=': (v1, v2) => v1 != v2,
        '!==': (v1, v2) => v1 !== v2,
        '<': (v1, v2) => v1 < v2,
        '<=' : (v1, v2) => v1 <= v2,
        '>' : (v1, v2) => v1 > v2,
        '>=' : (v1, v2) => v1 >= v2,
        '&&' : (v1, v2) => v1 && v2,
        '||' : (v1, v2) => v1 || v2,
        undefined : () => options.inverse(this)
      };
      return conditions[operator](v1,v2) ? options.fn(this) : options.inverse(this);
    },
    defined: function() {
      return !Array.from(arguments).some((argument) => {
        return argument === undefined;
      });
    }
  },
  finish_blocks: function(template){
    //TODO: review this code and see if it should be removed
    for (var b in HandlebarsExtensions._blocks) {
      var content = HandlebarsExtensions._blocks[b].join('\n');
      template = template.replace('{{block:' + b + '}}', content);
    }
    HandlebarsExtensions._blocks = [];
    return template;
  }
};

for(var helper in HandlebarsExtensions.helpers){
  if (HandlebarsExtensions.helpers.hasOwnProperty(helper) && typeof(HandlebarsExtensions.helpers[helper]) === 'function'){
    Handlebars.registerHelper(helper, HandlebarsExtensions.helpers[helper]);
  }
}
